<template>
  <div class="govui-grid">
    <router-view v-if="userHasLoaded" />
    <b-loading v-else isFullPage active>
      <CustomLoaderAnimation />
    </b-loading>
    <GAInfo />
  </div>
</template>

<script>
import { ApiInterception } from "@/services/api/ApiExceptions";
import { mapGetters, mapActions, mapMutations } from "vuex";
import CustomLoaderAnimation from "@/components/CustomLoaderAnimation";
import GAInfo from "@/components/GAInfo";
import { LOGIN_URL } from "@/utils/enumerate";

export default {
  name: "App",

  components: { CustomLoaderAnimation, GAInfo },

  data() {
    return {
      userHasLoaded: false
    };
  },

  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      isAuthenticated: "isAuthenticated",
      hasSomePermission: "hasSomePermission"
    }),

    hasUserDataMissing() {
      return (
        !Object.keys(this.user).length ||
        !this.isAuthenticated ||
        !this.user.bonds
      );
    }
  },

  watch: {
    isAuthenticated: {
      async handler() {
        const token = localStorage.getItem("token");
        if (token && !this.isAuthenticated) this.$store.dispatch("authLogout");
      },
      deep: true
    }
  },

  async created() {
    ApiInterception(401, error => {
      if (![LOGIN_URL].includes(error.config.url)) {
        this.$store.commit("invalidToken");
      }
    });

    const token = localStorage.getItem("token");

    document.addEventListener("keydown", e => {
      this.keyCombinationCheck(e);
    });

    if (token) {
      if (this.hasUserDataMissing) {
        const userData = await this.$store.dispatch("userDataRequest");
        this.$store.commit("loginUser", { token, userData, isUpdate: true });
      }
      this.userHasLoaded = true;
      await Promise.allSettled([
        this.holidaysRequest(),
        this.capacityRequestAll(),
        this.partRequest(),
        this.requestVersion({ last: true })
      ]);

      const pathDoc = localStorage.getItem("goDoc");
      if (pathDoc) {
        this.$router.push(pathDoc);
        localStorage.removeItem("goDoc");
      }
    } else
      await Promise.allSettled([
        this.capacityRequestAll(),
        this.partRequest(),
        this.requestVersion({ last: true })
      ]);

    this.userHasLoaded = true;
  },

  beforeMount() {
    const token = this.$route.query.p;
    if (token) {
      this.userHasLoaded = false;
      this.loginWithTokenGuardian(token)
        .then(result => this.$router.replace(result ? "/app" : "/"))
        .finally(() => (this.userHasLoaded = true));
    }
  },

  methods: {
    ...mapActions({
      holidaysRequest: "holidaysRequest",
      capacityRequest: "capacityRequest",
      partRequest: "partRequest",
      requestVersion: "requestVersion",
      loginWithTokenGuardian: "authLoginGuardian"
    }),

    ...mapMutations({
      toggleTheme: "toggleTheme"
    }),

    async capacityRequestAll() {
      await this.capacityRequest({ all: true });
    },

    keyCombinationCheck(event) {
      if (event.altKey && event.key === "c") {
        this.toggleTheme();
      }
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/main";
@font-face {
  font-family: "Arial Nova Light";
  src: "@/assets/fonts/arial-nova-light.ttf";
}
</style>
